// 特殊配规配送类型
export enum DeliveryType {
    '仅自提'  = 1,
    '仅配送',
    '配送+自提',
    '快递'
}
// 审核状态
export enum ApprovalStatus {
    '待审核' = 1,
    '审核通过',
    '驳回'
}
